import type {
  PropsWithClient,
  SearchAdapter,
  SearchAdapterOptions,
} from "src/types/adapters/search.type";
import type {
  BrowseableEntity,
  BrowseParams,
} from "src/types/adapters/browse.type";
import { browse } from "./browse";
import { query } from "./query";
import { queryRecommendations } from "./query-recommendations";
import { listing } from "./listing";
import {
  getConstructorClient,
  type ConstructorClient,
} from "src/lib/constructor";

export type PropsWithConstructorClient<T> = PropsWithClient<
  ConstructorClient,
  T
>;

export function constructorSearchAdapter(
  options: SearchAdapterOptions
): SearchAdapter {
  const client = getConstructorClient(options.env);
  client.setUserId(options.userId);

  return {
    query: (searchQuery, params) =>
      query({ client, options, query: searchQuery, params }),
    queryRecommendations: (params) =>
      queryRecommendations({ client, params, options }),
    listing: (params) => listing({ client, params, options }),
    browse: <E extends BrowseableEntity>(params: BrowseParams<E>) =>
      browse<E>({ client, params, options }),
  };
}
